// // import React, { useState } from 'react';
// // import BreadCrumb from '../../components/template/BreadCrumb';
// // import Header from '../../components/template/Header';
// // import { Link } from 'react-router-dom';
// // import { useHistory } from 'react-router-dom';
// // import Spinner from '../../components/layout/Spinner';
// // import AddForm from '../../components/common/AddForm';
// // import { convertToFormData } from '../../shared/upload';
// // import {
// //   initialValues,
// //   inputFields,
// //   PAGE_TITLE,
// //   PAGE_SINGLE_TITLE,
// //   LINK_URL,
// // } from '../../shared/enums/activitys_enum';
// // import {
// //   useUpdateActivity,
// //   useSingleActivity,
// //   useGetDropdownOptions,
// // } from '../../shared/hooks/UseActivity';
// // // import { useSelectAllActivity } from "../../shared/hooks/UseActivity";
// // import { FieldArray, Form, Formik } from 'formik';
// // import * as Yup from 'yup';
// // import {
// //   CheckBox,
// //   SelectBox,
// //   TextArea,
// //   TextInput,
// // } from '../../components/Form/Form';
// // import { useSelectAllProcess } from '../../shared/hooks/UseProcess';
// // import EditorWYSIWYG from '../../components/EditorWYSIWYG';
// // import moment from 'moment';

// // const EditActivity = ({ match }) => {
// //   let history = useHistory();
// //   const [single_data] = useSingleActivity(match.params.id);
// //   const [updateData] = useUpdateActivity();
// //   const { activity_loading, activity, edit_activity_loading } = single_data;
// //   const [featuredImage, setFeaturedImage] = useState(null);
// //   const [imagePicked, setImagePicked] = useState(null);
// //   const pickImage = ({ field, value }) => {
// //     // console.log("CALLING", field);
// //     let imagesCollection = imagePicked ? imagePicked : {};
// //     imagesCollection[field] = value;
// //     console.log('FILES', imagesCollection);
// //     setImagePicked(imagesCollection);
// //     setFeaturedImage(imagesCollection);
// //   };

// //   console.log('ACTIVITY -', activity);

// //   const [process_data] = useSelectAllProcess();
// //   const { all_processs } = process_data;

// //   const submitFormClicked = async (values) => {
// //     const data = await convertToFormData({ values, featuredImage });
// //     await updateData(activity._id, data);
// //     history.push(`/${LINK_URL}/${activity._id}/view`);
// //   };

// //   const [
// //     dropdownOptions,
// //     setEmployeeSearchField,
// //     setEmployeeSearchValue,
// //     setClientSearchField,
// //     setClientSearchValue,
// //     setProcessSearchField,
// //     setProcessSearchValue,
// //     setActivitystatusSearchField,
// //     setActivitystatusSearchValue,
// //     setReviewstatusSearchField,
// //     setReviewstatusSearchValue,
// //   ] = useGetDropdownOptions();

// //   const loadOptions = async (inputValue, callback, field) => {
// //     if (field == 'assigned_to') {
// //       setEmployeeSearchField('name');
// //       setEmployeeSearchValue(inputValue);
// //       callback(dropdownOptions.assigned_to);
// //     }
// //     if (field == 'client') {
// //       setClientSearchField('name');
// //       setClientSearchValue(inputValue);
// //       callback(dropdownOptions.client);
// //     }
// //     if (field == 'process') {
// //       setProcessSearchField('name');
// //       setProcessSearchValue(inputValue);
// //       callback(dropdownOptions.process);
// //     }
// //     if (field == 'activity_status') {
// //       setActivitystatusSearchField('name');
// //       setActivitystatusSearchValue(inputValue);
// //       callback(dropdownOptions.activity_status);
// //     }
// //     if (field == 'review_status') {
// //       setReviewstatusSearchField('name');
// //       setReviewstatusSearchValue(inputValue);
// //       callback(dropdownOptions.review_status);
// //     }
// //   };

// //   return (
// //     <div className='pace-done'>
// //       <div>
// //         <Header />
// //         <BreadCrumb
// //           title={`Edit ${PAGE_SINGLE_TITLE}`}
// //           mainLinkTitle={PAGE_TITLE}
// //           mainLinkUrl={LINK_URL}
// //           activeLink='Edit'
// //         />
// //       </div>
// //       <div className='container-fluid'>
// //         <div className='col-lg-12'>
// //           <div className='card'>
// //             {!activity_loading ? (
// //               activity && (
// //                 <div>
// //                   <div className='card-header'>
// //                     <div>
// //                       <h4 className='card-title'>
// //                         {activity[Object.keys(inputFields)[0]]} -{' '}
// //                         <span>Edit</span>{' '}
// //                       </h4>
// //                       <p className='card-title-desc'>
// //                         <Link
// //                           to={`/${LINK_URL}`}
// //                           className='btn btn-soft-light'
// //                         >
// //                           <i className='fa fa-angle-left'></i> {PAGE_TITLE}
// //                         </Link>
// //                         <Link
// //                           to={`/${LINK_URL}/${activity._id}/view`}
// //                           className='btn btn-soft-light'
// //                         >
// //                           <i className='fa fa-eye'></i>
// //                         </Link>
// //                       </p>
// //                     </div>
// //                   </div>
// //                   <div className='container-fluid'>
// //                     <Formik
// //                       initialValues={{
// //                         task_name:
// //                           activity && activity.task_name
// //                             ? activity.task_name
// //                             : '',
// //                         assigned_to:
// //                           activity &&
// //                           activity.assigned_to &&
// //                           activity.assigned_to._id
// //                             ? activity.assigned_to._id
// //                             : '',
// //                         activity_cycle:
// //                           activity && activity.activity_cycle
// //                             ? activity.activity_cycle._id
// //                             : '',
// //                         due_time:
// //                           activity && activity.due_time
// //                             ? moment(activity.due_time).format(
// //                                 'yyyy-MM-DDThh:mm'
// //                               )
// //                             : '',
// //                         client:
// //                           activity && activity.client && activity.client._id
// //                             ? activity.client._id
// //                             : '',
// //                         process:
// //                           activity && activity.process && activity.process._id
// //                             ? activity.process._id
// //                             : '',
// //                         checklist: activity.checklist ? activity.checklist : [],
// //                         estimated_time:
// //                           activity && activity.estimated_time
// //                             ? activity.estimated_time
// //                             : '',
// //                         actual_time:
// //                           activity && activity.actual_time
// //                             ? activity.actual_time
// //                             : '',
// //                         task_description:
// //                           activity && activity.task_description
// //                             ? activity.task_description
// //                             : '',
// //                         attachments:
// //                           activity && activity.attachments
// //                             ? activity.attachments
// //                             : '',
// //                         review_status:
// //                           activity &&
// //                           activity.review_status &&
// //                           activity.review_status._id
// //                             ? activity.review_status._id
// //                             : '',
// //                         activity_status:
// //                           activity &&
// //                           activity.activity_status &&
// //                           activity.activity_status._id
// //                             ? activity.activity_status._id
// //                             : '',
// //                         comments:
// //                           activity && activity.comments
// //                             ? activity.comments
// //                             : '',
// //                       }}
// //                       validationSchema={Yup.object({
// //                         task_name: Yup.string().required('Required'),
// //                         assigned_to: Yup.string().required('Required'),
// //                         due_time: Yup.string().required('Required'),
// //                         client: Yup.string().required('Required'),
// //                         process: Yup.string().required('Required'),
// //                         review_status: Yup.string().required('Required'),
// //                         activity_status: Yup.string().required('Required'),
// //                       })}
// //                       onSubmit={async (
// //                         values,
// //                         { setSubmitting, resetForm }
// //                       ) => {
// //                         setSubmitting(true);
// //                         // addData(values);
// //                         submitFormClicked(values);
// //                         resetForm();
// //                         setSubmitting(false);
// //                       }}
// //                     >
// //                       {(formik) => {
// //                         console.log(formik);
// //                         return (
// //                           <Form>
// //                             <div className='row'>
// //                               <div className='col-md-8'>
// //                                 <div className='add-activity-form-box'>
// //                                   <div className='add-activity-form-header'>
// //                                     <div className='add-activity-form-title'>
// //                                       Activity
// //                                     </div>
// //                                     <div className='add-activity-form-desc'>
// //                                       Enter Details to Edit Activity
// //                                     </div>
// //                                   </div>
// //                                   <hr />
// //                                   <div className='add-activity-form'>
// //                                     <div className='row'>
// //                                       <div className='col-md-6'>
// //                                         <TextInput
// //                                           label='Task Name'
// //                                           name='task_name'
// //                                           type='text'
// //                                           placeholder='Task Name'
// //                                         />
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Assigned to'
// //                                           name='assigned_to'
// //                                           placeholder='Enter Assigned to'
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Assigned to{' '}
// //                                           </option>
// //                                           {dropdownOptions.assigned_to &&
// //                                             dropdownOptions.assigned_to.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {' '}
// //                                                     {item.label}{' '}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Activity Cycle'
// //                                           name='activity_cycle'
// //                                           placeholder='Select'
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Assigned to{' '}
// //                                           </option>
// //                                           {dropdownOptions.activity_cycle &&
// //                                             dropdownOptions.activity_cycle.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {' '}
// //                                                     {item.label}{' '}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <TextInput
// //                                           label='Due Time'
// //                                           name='due_time'
// //                                           type='datetime-local'
// //                                           placeholder='Enter Due Time'
// //                                         />
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Client'
// //                                           name='client'
// //                                           placeholder='Enter Process'
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Client{' '}
// //                                           </option>
// //                                           {dropdownOptions.client &&
// //                                             dropdownOptions.client.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {' '}
// //                                                     {item.label}{' '}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Process'
// //                                           name='process'
// //                                           placeholder='Enter Process'
// //                                           onChange={(e) => {
// //                                             formik.setFieldValue(
// //                                               'process',
// //                                               e.target.value
// //                                             );
// //                                             formik.setFieldValue(
// //                                               'checklist',
// //                                               []
// //                                             );
// //                                             if (all_processs) {
// //                                               const filteredData =
// //                                                 all_processs.filter(
// //                                                   (item, index) =>
// //                                                     item._id == e.target.value
// //                                                 );
// //                                               if (
// //                                                 filteredData &&
// //                                                 filteredData.length > 0
// //                                               ) {
// //                                                 const checklistData =
// //                                                   filteredData[0].checklist;
// //                                                 if (
// //                                                   checklistData &&
// //                                                   checklistData.length > 0
// //                                                 ) {
// //                                                   const checklistDataMapped =
// //                                                     checklistData.map(
// //                                                       (item) => {
// //                                                         return {
// //                                                           name: item.name,
// //                                                           is_checked: false,
// //                                                         };
// //                                                       }
// //                                                     );
// //                                                   formik.setFieldValue(
// //                                                     'checklist',
// //                                                     checklistDataMapped
// //                                                   );
// //                                                 }
// //                                               }
// //                                             }
// //                                             // all_processs && all_processs.filter((item, index) => item._id == formik.values.process) && all_processs.filter((item) => item._id == formik.values.process)[0] && all_processs.filter((item) => item._id == formik.values.process)[0].checklist && all_processs.filter((item) => item._id == formik.values.process)[0].checklist
// //                                           }}
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Process{' '}
// //                                           </option>
// //                                           {dropdownOptions.process &&
// //                                             dropdownOptions.process.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {' '}
// //                                                     {item.label}{' '}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <TextInput
// //                                           label='Estimated Time(in mins)'
// //                                           name='estimated_time'
// //                                           type='text'
// //                                           placeholder='Enter Estimated time(in mins)'
// //                                         />
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <TextInput
// //                                           label='Actual Time'
// //                                           name='actual_time'
// //                                           type='text'
// //                                           placeholder='Enter Actual Time'
// //                                         />
// //                                       </div>
// //                                       <div className='col-md-12'>
// //                                         <div className='form-group'>
// //                                           <label> Task Description </label>
// //                                           <EditorWYSIWYG
// //                                             value={
// //                                               formik.values.task_description
// //                                                 ? formik.values.task_description
// //                                                 : ''
// //                                             }
// //                                             name={'task_description'}
// //                                             changeValue={(value) => {
// //                                               formik.setFieldValue(
// //                                                 'task_description',
// //                                                 value
// //                                               );
// //                                             }}
// //                                           />
// //                                           {formik.errors &&
// //                                             formik.errors[
// //                                               'task_description'
// //                                             ] && (
// //                                               <p className='text-danger'>
// //                                                 {' '}
// //                                                 Required{' '}
// //                                               </p>
// //                                             )}
// //                                         </div>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <label> Attachments </label>
// //                                         <br />
// //                                         <input
// //                                           type='file'
// //                                           multiple
// //                                           className='form-control-file'
// //                                           onChange={(e) =>
// //                                             pickImage({
// //                                               field: 'attachments',
// //                                               value: e.target.files,
// //                                             })
// //                                           }
// //                                         />
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Review Status'
// //                                           name='review_status'
// //                                           placeholder='Enter Review Status'
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Review Status{' '}
// //                                           </option>
// //                                           {dropdownOptions.review_status &&
// //                                             dropdownOptions.review_status.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {item.label}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <SelectBox
// //                                           label='Activity Status'
// //                                           name='activity_status'
// //                                           placeholder='Enter Activity Status'
// //                                         >
// //                                           <option value=''>
// //                                             {' '}
// //                                             Select Activity Status{' '}
// //                                           </option>
// //                                           {dropdownOptions.activity_status &&
// //                                             dropdownOptions.activity_status.map(
// //                                               (item) => {
// //                                                 return (
// //                                                   <option value={item.value}>
// //                                                     {item.label}
// //                                                   </option>
// //                                                 );
// //                                               }
// //                                             )}
// //                                         </SelectBox>
// //                                       </div>
// //                                       <div className='col-md-6'>
// //                                         <TextArea
// //                                           label='Comments'
// //                                           name='comment'
// //                                           type='text'
// //                                           placeholder='Enter Comments'
// //                                         />
// //                                       </div>
// //                                     </div>
// //                                     <div className='row'>
// //                                       <div className='col-md-12 text-center m-3'>
// //                                         <button
// //                                           type='submit'
// //                                           className='btn btn-success'
// //                                         >
// //                                           {formik.isSubmitting
// //                                             ? 'Processing...'
// //                                             : 'Save'}
// //                                         </button>
// //                                         <a
// //                                           className='btn btn-secondary m-3'
// //                                           // onClick={history.goBack}
// //                                           href='#goback'
// //                                         >
// //                                           <i className='fa fa-angle-left'></i>{' '}
// //                                           Go Back
// //                                         </a>
// //                                       </div>
// //                                     </div>
// //                                   </div>
// //                                 </div>
// //                               </div>
// //                               <div className='col-md-4'>
// //                                 <div className='card'>
// //                                   <div className='card-header'>
// //                                     <div className='card-title-side'>
// //                                       <h4>Checklist:</h4>
// //                                     </div>
// //                                   </div>
// //                                   <div className='card-body-p-8'>
// //                                     <div className='card-body-single-data'>
// //                                       <div className='card-body-received-datalist'>
// //                                         <FieldArray
// //                                           name='checklist'
// //                                           render={(arrayHelper) => {
// //                                             return (
// //                                               <div>
// //                                                 {formik.values.checklist &&
// //                                                   formik.values.checklist.map(
// //                                                     (item, index) => {
// //                                                       return (
// //                                                         <div className='card-body-received-data d-flex'>
// //                                                           <div className='col-md-6'>
// //                                                             <CheckBox
// //                                                               // label={item.name}
// //                                                               name={`checklist[${index}].is_checked`}
// //                                                               type='checkbox'
// //                                                               className='pt-0'
// //                                                             >
// //                                                               {item.name}
// //                                                             </CheckBox>
// //                                                           </div>
// //                                                         </div>
// //                                                       );
// //                                                     }
// //                                                   )}
// //                                               </div>
// //                                             );
// //                                           }}
// //                                         ></FieldArray>
// //                                       </div>
// //                                     </div>
// //                                   </div>
// //                                 </div>
// //                                 <div className='card'>
// //                                   <div className='card-header'>
// //                                     <div className='card-title-side'>
// //                                       <h4>Standard Operating Procedure:</h4>
// //                                     </div>
// //                                   </div>
// //                                   <div className='card-body'>
// //                                     <div className='card-body-single-data'>
// //                                       <div className='card-body-received-datalist'>
// //                                         {all_processs &&
// //                                           all_processs.filter(
// //                                             (item) =>
// //                                               item._id == formik.values.process
// //                                           ) &&
// //                                           all_processs.filter(
// //                                             (item) =>
// //                                               item._id == formik.values.process
// //                                           )[0] &&
// //                                           all_processs.filter(
// //                                             (item) =>
// //                                               item._id == formik.values.process
// //                                           )[0].sop &&
// //                                           all_processs
// //                                             .filter(
// //                                               (item) =>
// //                                                 item._id ==
// //                                                 formik.values.process
// //                                             )[0]
// //                                             .sop.map((item) => {
// //                                               return (
// //                                                 <div className='card-body-received-data d-flex pb-3'>
// //                                                   <div className='checklist-data-list-img'>
// //                                                     <img
// //                                                       src='/images/sop_3.png'
// //                                                       alt=''
// //                                                     />
// //                                                   </div>
// //                                                   <div className='checklist-data-content'>
// //                                                     <div
// //                                                       dangerouslySetInnerHTML={{
// //                                                         __html: item.name,
// //                                                       }}
// //                                                     ></div>
// //                                                   </div>
// //                                                 </div>
// //                                               );
// //                                             })}
// //                                       </div>
// //                                     </div>
// //                                   </div>
// //                                 </div>
// //                               </div>
// //                             </div>
// //                           </Form>
// //                         );
// //                       }}
// //                     </Formik>
// //                   </div>
// //                 </div>
// //               )
// //             ) : (
// //               <div className='text-center'>
// //                 <Spinner />
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default EditActivity;

// 'use client';

// import { useState, useEffect } from 'react';
// import BreadCrumb from '../../components/template/BreadCrumb';
// import Header from '../../components/template/Header';
// import { Link } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
// import Spinner from '../../components/layout/Spinner';
// import { convertToFormData, uploadGallery } from '../../shared/upload';
// import {
//   inputFields,
//   PAGE_TITLE,
//   PAGE_SINGLE_TITLE,
//   LINK_URL,
// } from '../../shared/enums/activitys_enum';
// import {
//   useUpdateActivity,
//   useSingleActivity,
//   useGetDropdownOptions,
// } from '../../shared/hooks/UseActivity';
// import { FieldArray, Form, Formik } from 'formik';
// import * as Yup from 'yup';
// import {
//   CheckBox,
//   SelectBox,
//   TextArea,
//   TextInput,
// } from '../../components/Form/Form';
// import { useSelectAllProcess } from '../../shared/hooks/UseProcess';
// import EditorWYSIWYG from '../../components/EditorWYSIWYG';
// import moment from 'moment';
// import { useMutation } from '@tanstack/react-query';
// import api from '../../domain/api';
// import toast from 'react-hot-toast';
// import { URI } from '../../domain/constant';

// const EnhancedEditActivity = ({ match }) => {
//   const history = useHistory();
//   const [single_data] = useSingleActivity(match.params.id);
//   const [updateData] = useUpdateActivity();
//   const { activity_loading, activity, edit_activity_loading } = single_data;
//   const [featuredImage, setFeaturedImage] = useState(null);
//   const [imagePicked, setImagePicked] = useState(null);
//   const [attachmentPreviews, setAttachmentPreviews] = useState([]);
//   const [existingAttachments, setExistingAttachments] = useState([]);
//   const [isDragOver, setIsDragOver] = useState(false);

//   const [process_data] = useSelectAllProcess();
//   const { all_processs } = process_data;

//   console.log('existingAttachments', existingAttachments);

//   // Handle existing attachments when activity loads
//   useEffect(() => {
//     if (activity && activity.attachments) {
//       const existing = Array.isArray(activity?.attachments)
//         ? activity?.attachments?.map((attachment, index) => {
//             // Get file extension for type
//             const ext = attachment.split('.').pop().toLowerCase();
//             let type = '';
//             if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext))
//               type = 'image/*';
//             else if (['pdf'].includes(ext)) type = 'application/pdf';
//             else if (['doc', 'docx'].includes(ext)) type = 'application/msword';
//             else if (['xls', 'xlsx'].includes(ext))
//               type = 'application/vnd.ms-excel';
//             else if (['zip', 'rar'].includes(ext)) type = 'application/zip';
//             else type = '';
//             return {
//               id: `existing-${index}`,
//               name: attachment?.split(/[\\/]/).pop() || 'Unknown file',
//               url: attachment?.startsWith('http')
//                 ? attachment
//                 : `${process.env.REACT_APP_API_URL || ''}${attachment}`,
//               isExisting: true,
//               type,
//             };
//           })
//         : [];
//       setExistingAttachments(existing);
//     }
//   }, [activity]);

//   const pickImage = ({ field, value }) => {
//     const imagesCollection = imagePicked ? imagePicked : {};
//     imagesCollection[field] = value;

//     setImagePicked(imagesCollection);
//     setFeaturedImage(imagesCollection);

//     // Create previews for new attachments
//     if (field === 'attachments' && value) {
//       const files = Array.from(value);
//       const previews = files.map((file, index) => ({
//         id: Date.now() + index,
//         file: file,
//         name: file.name,
//         size: file.size,
//         type: file.type,
//         preview: file.type.startsWith('image/')
//           ? URL.createObjectURL(file)
//           : null,
//         isExisting: false,
//       }));
//       setAttachmentPreviews(previews);
//     }
//   };

//   const removeAttachment = (id, isExisting = false) => {
//     if (isExisting) {
//       setExistingAttachments((prev) => prev?.filter((item) => item.id !== id));
//     } else {
//       const updatedPreviews = attachmentPreviews.filter(
//         (item) => item.id !== id
//       );
//       setAttachmentPreviews(updatedPreviews);

//       // Update the actual files
//       const updatedFiles = updatedPreviews.map((item) => item.file);
//       const fileList = new DataTransfer();
//       updatedFiles.forEach((file) => fileList.items.add(file));

//       pickImage({
//         field: 'attachments',
//         value: fileList.files,
//       });
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragOver(false);
//     const files = Array.from(e.dataTransfer.files);
//     const fileList = new DataTransfer();
//     files.forEach((file) => fileList.items.add(file));

//     pickImage({
//       field: 'attachments',
//       value: fileList.files,
//     });
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragOver(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setIsDragOver(false);
//   };

//   const formatFileSize = (bytes) => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return (
//       Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
//     );
//   };

//   const getFileIcon = (type) => {
//     if (type && type.startsWith('image/')) return 'fa-image';
//     if (type && type.includes('pdf')) return 'fa-file-pdf';
//     if (type && type.includes('word')) return 'fa-file-word';
//     if (
//       (type && type.includes('excel')) ||
//       (type && type.includes('spreadsheet'))
//     )
//       return 'fa-file-excel';
//     if ((type && type.includes('zip')) || (type && type.includes('rar')))
//       return 'fa-file-archive';
//     return 'fa-file';
//   };

//   const editActivityMutation = useMutation({
//     mutationFn: async (data) => {
//       const resp = await api.put(`/activitys/${data?.id}`, data);
//       return resp.data;
//     },

//     onSuccess: () => {
//       toast.success('Activity updated successfully!');

//       history.push(`/${LINK_URL}/${match.params.id}/view`);
//     },

//     onError: (error) => {
//       toast.error('Failed to update activity: ' + error.message);
//     },
//   });

//   const submitFormClicked = async (values) => {
//     const uploaded = await uploadGallery(featuredImage.attachments);

//     editActivityMutation.mutate({
//       ...values,
//       id: activity._id,
//       attachments: [
//         ...uploaded,
//         ...(existingAttachments?.map((item) => item.url) || []),
//       ],
//     });
//   };

//   const [dropdownOptions] = useGetDropdownOptions();

//   if (activity_loading) {
//     return (
//       <div className='pace-done'>
//         <div>
//           <Header />
//           <BreadCrumb
//             title={`Edit ${PAGE_SINGLE_TITLE}`}
//             mainLinkTitle={PAGE_TITLE}
//             mainLinkUrl={LINK_URL}
//             activeLink='Edit'
//           />
//         </div>
//         <div
//           className='d-flex justify-content-center align-items-center'
//           style={{ minHeight: '50vh' }}
//         >
//           <Spinner />
//         </div>
//       </div>
//     );
//   }

//   if (!activity) {
//     return (
//       <div className='pace-done'>
//         <div>
//           <Header />
//           <BreadCrumb
//             title={`Edit ${PAGE_SINGLE_TITLE}`}
//             mainLinkTitle={PAGE_TITLE}
//             mainLinkUrl={LINK_URL}
//             activeLink='Edit'
//           />
//         </div>
//         <div className='container-fluid'>
//           <div className='alert alert-warning'>Activity not found</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style jsx>{`
//         .enhanced-activity-container {
//           background: linear-gradient(
//             135deg,
//             #f8fafc 0%,
//             #fef2f2 50%,
//             #fff1f2 100%
//           );
//           min-height: 100vh;
//           padding: 20px 0;
//         }

//         .enhanced-form-card {
//           background: white;
//           border-radius: 16px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
//           border: 1px solid #f1f5f9;
//           overflow: hidden;
//           margin-bottom: 24px;
//         }

//         .enhanced-form-header {
//           background: linear-gradient(
//             135deg,
//             #1e293b 0%,
//             #334155 25%,
//             #dc2626 75%,
//             #b91c1c 100%
//           );
//           color: white;
//           padding: 24px 28px;
//           position: relative;
//         }

//         .enhanced-form-header::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: linear-gradient(
//             45deg,
//             rgba(255, 255, 255, 0.1) 0%,
//             transparent 50%
//           );
//           pointer-events: none;
//         }

//         .enhanced-form-title {
//           font-size: 24px;
//           font-weight: 700;
//           margin: 0 0 8px 0;
//           position: relative;
//           z-index: 1;
//         }

//         .enhanced-form-subtitle {
//           font-size: 14px;
//           opacity: 0.9;
//           margin: 0;
//           position: relative;
//           z-index: 1;
//         }

//         .enhanced-form-actions-header {
//           display: flex;
//           gap: 12px;
//           margin-top: 16px;
//         }

//         .enhanced-header-btn {
//           background: rgba(255, 255, 255, 0.2);
//           color: white;
//           border: 1px solid rgba(255, 255, 255, 0.3);
//           border-radius: 6px;
//           padding: 8px 16px;
//           font-size: 12px;
//           font-weight: 500;
//           text-decoration: none;
//           transition: all 0.2s ease;
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//         }

//         .enhanced-header-btn:hover {
//           background: rgba(255, 255, 255, 0.3);
//           color: white;
//           text-decoration: none;
//           transform: translateY(-1px);
//         }

//         .enhanced-form-body {
//           padding: 32px 28px;
//         }

//         .enhanced-form-section {
//           margin-bottom: 32px;
//         }

//         .enhanced-section-title {
//           font-size: 18px;
//           font-weight: 600;
//           color: #1f2937;
//           margin-bottom: 20px;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .enhanced-section-icon {
//           width: 32px;
//           height: 32px;
//           background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-size: 14px;
//         }

//         /* Enhanced Form Controls */
//         .form-group {
//           margin-bottom: 24px;
//         }

//         .form-group label {
//           font-weight: 600;
//           color: #374151;
//           margin-bottom: 8px;
//           display: block;
//           font-size: 14px;
//         }

//         .form-control {
//           border: 2px solid #e5e7eb;
//           border-radius: 8px;
//           padding: 12px 16px;
//           font-size: 14px;
//           transition: all 0.2s ease;
//           background: #fafafa;
//         }

//         .form-control:focus {
//           outline: none;
//           border-color: #dc2626;
//           background: white;
//           box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
//         }

//         /* Enhanced Attachment Section */
//         .enhanced-attachment-section {
//           background: #f9fafb;
//           border: 2px dashed #d1d5db;
//           border-radius: 12px;
//           padding: 24px;
//           text-align: center;
//           transition: all 0.3s ease;
//           cursor: pointer;
//           position: relative;
//         }

//         .enhanced-attachment-section.drag-over {
//           border-color: #dc2626;
//           background: #fef2f2;
//           transform: scale(1.02);
//         }

//         .enhanced-attachment-section:hover {
//           border-color: #dc2626;
//           background: #fef2f2;
//         }

//         .attachment-upload-icon {
//           width: 64px;
//           height: 64px;
//           background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 16px;
//           color: white;
//           font-size: 24px;
//         }

//         .attachment-upload-title {
//           font-size: 18px;
//           font-weight: 600;
//           color: #1f2937;
//           margin-bottom: 8px;
//         }

//         .attachment-upload-subtitle {
//           font-size: 14px;
//           color: #6b7280;
//           margin-bottom: 16px;
//         }

//         .attachment-upload-button {
//           background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
//           color: white;
//           border: none;
//           border-radius: 8px;
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.2s ease;
//         }

//         .attachment-upload-button:hover {
//           transform: translateY(-1px);
//           box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
//         }

//         .attachment-file-input {
//           position: absolute;
//           opacity: 0;
//           width: 100%;
//           height: 100%;
//           cursor: pointer;
//         }

//         /* Attachment Previews */
//         .attachment-previews {
//           margin-top: 20px;
//         }

//         .attachment-preview-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//           gap: 16px;
//           margin-top: 16px;
//         }

//         .attachment-preview-card {
//           background: white;
//           border: 1px solid #e5e7eb;
//           border-radius: 12px;
//           padding: 16px;
//           transition: all 0.2s ease;
//           position: relative;
//         }

//         .attachment-preview-card.existing {
//           border-color: #10b981;
//           background: #f0fdf4;
//         }

//         .attachment-preview-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//         }

//         .attachment-preview-header {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-bottom: 12px;
//         }

//         .attachment-file-icon {
//           width: 40px;
//           height: 40px;
//           background: #f3f4f6;
//           border-radius: 8px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: #6b7280;
//           font-size: 16px;
//         }

//         .attachment-file-info {
//           flex: 1;
//           min-width: 0;
//         }

//         .attachment-file-name {
//           font-size: 14px;
//           font-weight: 600;
//           color: #1f2937;
//           margin: 0 0 4px 0;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .attachment-file-size {
//           font-size: 12px;
//           color: #6b7280;
//           margin: 0;
//         }

//         .attachment-existing-badge {
//           font-size: 10px;
//           background: #10b981;
//           color: white;
//           padding: 2px 6px;
//           border-radius: 4px;
//           margin: 0;
//         }

//         .attachment-remove-btn {
//           position: absolute;
//           top: 8px;
//           right: 8px;
//           background: #ef4444;
//           color: white;
//           border: none;
//           border-radius: 50%;
//           width: 24px;
//           height: 24px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           font-size: 12px;
//           transition: all 0.2s ease;
//         }

//         .attachment-remove-btn:hover {
//           background: #dc2626;
//           transform: scale(1.1);
//         }

//         .attachment-image-preview {
//           width: 100%;
//           height: 120px;
//           object-fit: cover;
//           border-radius: 8px;
//           margin-bottom: 12px;
//         }

//         /* Sidebar Cards */
//         .enhanced-sidebar-card {
//           background: white;
//           border-radius: 12px;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
//           border: 1px solid #f1f5f9;
//           margin-bottom: 20px;
//           overflow: hidden;
//         }

//         .enhanced-sidebar-header {
//           background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
//           padding: 16px 20px;
//           border-bottom: 1px solid #e5e7eb;
//         }

//         .enhanced-sidebar-title {
//           font-size: 16px;
//           font-weight: 600;
//           color: #1f2937;
//           margin: 0 0 4px 0;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhanced-sidebar-subtitle {
//           font-size: 12px;
//           color: #6b7280;
//           margin: 0;
//         }

//         .enhanced-sidebar-body {
//           padding: 20px;
//         }

//         .checklist-item {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           padding: 12px;
//           background: #f9fafb;
//           border: 1px solid #e5e7eb;
//           border-radius: 8px;
//           margin-bottom: 8px;
//           transition: all 0.2s ease;
//         }

//         .checklist-item:hover {
//           background: #f3f4f6;
//         }

//         .checklist-item input[type='checkbox'] {
//           width: 18px;
//           height: 18px;
//           accent-color: #dc2626;
//         }

//         .checklist-item label {
//           font-size: 14px;
//           color: #374151;
//           margin: 0;
//           cursor: pointer;
//           flex: 1;
//         }

//         .sop-item {
//           display: flex;
//           gap: 12px;
//           padding: 12px;
//           background: #f9fafb;
//           border: 1px solid #e5e7eb;
//           border-radius: 8px;
//           margin-bottom: 12px;
//         }

//         .sop-icon {
//           width: 32px;
//           height: 32px;
//           background: #dc2626;
//           border-radius: 6px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-size: 14px;
//           flex-shrink: 0;
//         }

//         .sop-content {
//           flex: 1;
//           font-size: 14px;
//           color: #374151;
//           line-height: 1.5;
//         }

//         /* Enhanced Buttons */
//         .enhanced-btn {
//           padding: 12px 24px;
//           border-radius: 8px;
//           font-size: 14px;
//           font-weight: 600;
//           transition: all 0.2s ease;
//           border: none;
//           cursor: pointer;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhanced-btn-primary {
//           background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
//           color: white;
//           box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
//         }

//         .enhanced-btn-primary:hover {
//           transform: translateY(-1px);
//           box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
//         }

//         .enhanced-btn-secondary {
//           background: #f8f9fa;
//           color: #6b7280;
//           border: 1px solid #e5e7eb;
//         }

//         .enhanced-btn-secondary:hover {
//           background: #e5e7eb;
//           color: #374151;
//         }

//         .enhanced-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .enhanced-btn-loading {
//           position: relative;
//         }

//         .enhanced-btn-loading::before {
//           content: '';
//           position: absolute;
//           left: 50%;
//           top: 50%;
//           transform: translate(-50%, -50%);
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           0% {
//             transform: translate(-50%, -50%) rotate(0deg);
//           }
//           100% {
//             transform: translate(-50%, -50%) rotate(360deg);
//           }
//         }

//         /* Form Actions */
//         .enhanced-form-actions {
//           background: #f9fafb;
//           border-top: 1px solid #e5e7eb;
//           padding: 20px 28px;
//           display: flex;
//           justify-content: center;
//           gap: 16px;
//         }

//         /* Responsive Design */
//         @media (max-width: 768px) {
//           .enhanced-form-body {
//             padding: 20px;
//           }

//           .enhanced-form-header {
//             padding: 20px;
//           }

//           .attachment-preview-grid {
//             grid-template-columns: 1fr;
//           }

//           .enhanced-form-actions {
//             padding: 16px 20px;
//             flex-direction: column;
//           }
//         }
//       `}</style>

//       <div className='pace-done'>
//         <div>
//           <Header />
//           <BreadCrumb
//             title={`Edit ${PAGE_SINGLE_TITLE}`}
//             mainLinkTitle={PAGE_TITLE}
//             mainLinkUrl={LINK_URL}
//             activeLink='Edit'
//           />
//         </div>

//         <div className='enhanced-activity-container'>
//           <div className='container-fluid'>
//             <div className='col-lg-12'>
//               <Formik
//                 initialValues={{
//                   task_name:
//                     activity && activity.task_name ? activity.task_name : '',
//                   assigned_to:
//                     activity && activity.assigned_to && activity.assigned_to._id
//                       ? activity.assigned_to._id
//                       : '',
//                   activity_cycle:
//                     activity && activity.activity_cycle
//                       ? activity.activity_cycle._id
//                       : '',
//                   due_time:
//                     activity && activity.due_time
//                       ? moment(activity.due_time).format('yyyy-MM-DDThh:mm')
//                       : '',
//                   client:
//                     activity && activity.client && activity.client._id
//                       ? activity.client._id
//                       : '',
//                   process:
//                     activity && activity.process && activity.process._id
//                       ? activity.process._id
//                       : '',
//                   checklist: activity.checklist ? activity.checklist : [],
//                   estimated_time:
//                     activity && activity.estimated_time
//                       ? activity.estimated_time
//                       : '',
//                   actual_time:
//                     activity && activity.actual_time
//                       ? activity.actual_time
//                       : '',
//                   task_description:
//                     activity && activity.task_description
//                       ? activity.task_description
//                       : '',
//                   attachments:
//                     activity && activity.attachments
//                       ? activity.attachments
//                       : '',
//                   review_status:
//                     activity &&
//                     activity.review_status &&
//                     activity.review_status._id
//                       ? activity.review_status._id
//                       : '',
//                   activity_status:
//                     activity &&
//                     activity.activity_status &&
//                     activity.activity_status._id
//                       ? activity.activity_status._id
//                       : '',
//                   comments:
//                     activity && activity.comments ? activity.comments : '',
//                 }}
//                 validationSchema={Yup.object({
//                   task_name: Yup.string().required('Required'),
//                   assigned_to: Yup.string().required('Required'),
//                   due_time: Yup.string().required('Required'),
//                   client: Yup.string().required('Required'),
//                   process: Yup.string().required('Required'),
//                   review_status: Yup.string().required('Required'),
//                   activity_status: Yup.string().required('Required'),
//                 })}
//                 onSubmit={async (values, { setSubmitting, resetForm }) => {
//                   setSubmitting(true);
//                   submitFormClicked(values);
//                   setSubmitting(false);
//                 }}
//               >
//                 {(formik) => {
//                   return (
//                     <Form>
//                       <div className='row'>
//                         <div className='col-md-8'>
//                           <div className='enhanced-form-card'>
//                             <div className='enhanced-form-header'>
//                               <h2 className='enhanced-form-title'>
//                                 <i className='fa fa-edit me-2'></i>
//                                 {activity[Object.keys(inputFields)[0]]} - Edit
//                                 Activity
//                               </h2>
//                               <p className='enhanced-form-subtitle'>
//                                 Update the activity details below to modify the
//                                 existing task
//                               </p>
//                               <div className='enhanced-form-actions-header'>
//                                 <Link
//                                   to={`/${LINK_URL}`}
//                                   className='enhanced-header-btn'
//                                 >
//                                   <i className='fa fa-angle-left'></i>
//                                   {PAGE_TITLE}
//                                 </Link>
//                                 <Link
//                                   to={`/${LINK_URL}/${activity._id}/view`}
//                                   className='enhanced-header-btn'
//                                 >
//                                   <i className='fa fa-eye'></i>
//                                   View
//                                 </Link>
//                               </div>
//                             </div>

//                             <div className='enhanced-form-body'>
//                               {/* Basic Information Section */}
//                               <div className='enhanced-form-section'>
//                                 <h3 className='enhanced-section-title'>
//                                   <div className='enhanced-section-icon'>
//                                     <i className='fa fa-info'></i>
//                                   </div>
//                                   Basic Information
//                                 </h3>
//                                 <div className='row'>
//                                   <div className='col-md-6'>
//                                     <TextInput
//                                       label='Task Name'
//                                       name='task_name'
//                                       type='text'
//                                       placeholder='Enter task name'
//                                     />
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Assigned to</label>
//                                       <SelectBox
//                                         name='assigned_to'
//                                         placeholder='Select assigned person'
//                                       >
//                                         <option value=''>
//                                           Select Assigned to
//                                         </option>
//                                         {dropdownOptions.assigned_to &&
//                                           dropdownOptions.assigned_to.map(
//                                             (item) => (
//                                               <option
//                                                 key={item.value}
//                                                 value={item.value}
//                                               >
//                                                 {item.label}
//                                               </option>
//                                             )
//                                           )}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Activity Cycle</label>
//                                       <SelectBox
//                                         name='activity_cycle'
//                                         placeholder='Select cycle'
//                                       >
//                                         <option value=''>
//                                           Select Activity Cycle
//                                         </option>
//                                         {dropdownOptions.activity_cycle &&
//                                           dropdownOptions.activity_cycle.map(
//                                             (item) => (
//                                               <option
//                                                 key={item.value}
//                                                 value={item.value}
//                                               >
//                                                 {item.label}
//                                               </option>
//                                             )
//                                           )}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <TextInput
//                                       label='Due Time'
//                                       name='due_time'
//                                       type='datetime-local'
//                                       placeholder='Select due date and time'
//                                     />
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Client</label>
//                                       <SelectBox
//                                         name='client'
//                                         placeholder='Select client'
//                                       >
//                                         <option value=''>Select Client</option>
//                                         {dropdownOptions.client &&
//                                           dropdownOptions.client.map((item) => (
//                                             <option
//                                               key={item.value}
//                                               value={item.value}
//                                             >
//                                               {item.label}
//                                             </option>
//                                           ))}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Process</label>
//                                       <SelectBox
//                                         name='process'
//                                         placeholder='Select process'
//                                         onChange={(e) => {
//                                           formik.setFieldValue(
//                                             'process',
//                                             e.target.value
//                                           );
//                                           formik.setFieldValue('checklist', []);
//                                           if (all_processs) {
//                                             const filteredData =
//                                               all_processs.filter(
//                                                 (item, index) =>
//                                                   item._id == e.target.value
//                                               );
//                                             if (
//                                               filteredData &&
//                                               filteredData.length > 0
//                                             ) {
//                                               const checklistData =
//                                                 filteredData[0].checklist;
//                                               if (
//                                                 checklistData &&
//                                                 checklistData.length > 0
//                                               ) {
//                                                 const checklistDataMapped =
//                                                   checklistData.map((item) => {
//                                                     return {
//                                                       name: item.name,
//                                                       is_checked: false,
//                                                     };
//                                                   });
//                                                 formik.setFieldValue(
//                                                   'checklist',
//                                                   checklistDataMapped
//                                                 );
//                                               }
//                                             }
//                                           }
//                                         }}
//                                       >
//                                         <option value=''>Select Process</option>
//                                         {dropdownOptions.process &&
//                                           dropdownOptions.process.map(
//                                             (item) => (
//                                               <option
//                                                 key={item.value}
//                                                 value={item.value}
//                                               >
//                                                 {item.label}
//                                               </option>
//                                             )
//                                           )}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>

//                               {/* Time Tracking Section */}
//                               <div className='enhanced-form-section'>
//                                 <h3 className='enhanced-section-title'>
//                                   <div className='enhanced-section-icon'>
//                                     <i className='fa fa-clock'></i>
//                                   </div>
//                                   Time Tracking
//                                 </h3>
//                                 <div className='row'>
//                                   <div className='col-md-6'>
//                                     <TextInput
//                                       label='Estimated Time (minutes)'
//                                       name='estimated_time'
//                                       type='number'
//                                       placeholder='Enter estimated time'
//                                     />
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <TextInput
//                                       label='Actual Time (minutes)'
//                                       name='actual_time'
//                                       type='number'
//                                       placeholder='Enter actual time'
//                                     />
//                                   </div>
//                                 </div>
//                               </div>

//                               {/* Description Section */}
//                               <div className='enhanced-form-section'>
//                                 <h3 className='enhanced-section-title'>
//                                   <div className='enhanced-section-icon'>
//                                     <i className='fa fa-align-left'></i>
//                                   </div>
//                                   Task Description
//                                 </h3>
//                                 <div className='form-group'>
//                                   <EditorWYSIWYG
//                                     value={
//                                       formik.values.task_description
//                                         ? formik.values.task_description
//                                         : ''
//                                     }
//                                     name={'task_description'}
//                                     changeValue={(value) => {
//                                       formik.setFieldValue(
//                                         'task_description',
//                                         value
//                                       );
//                                     }}
//                                   />
//                                   {formik.errors &&
//                                     formik.errors['task_description'] && (
//                                       <p className='text-danger'>Required</p>
//                                     )}
//                                 </div>
//                               </div>

//                               {/* Enhanced Attachments Section */}
//                               <div className='enhanced-form-section'>
//                                 <h3 className='enhanced-section-title'>
//                                   <div className='enhanced-section-icon'>
//                                     <i className='fa fa-paperclip'></i>
//                                   </div>
//                                   Attachments
//                                 </h3>

//                                 {/* Existing Attachments */}
//                                 {existingAttachments.length > 0 && (
//                                   <div className='attachment-previews'>
//                                     <h5
//                                       style={{
//                                         fontSize: '16px',
//                                         fontWeight: '600',
//                                         marginBottom: '16px',
//                                       }}
//                                     >
//                                       <i className='fa fa-check-circle text-success me-2'></i>
//                                       Current Files (
//                                       {existingAttachments.length})
//                                     </h5>
//                                     <div className='attachment-preview-grid'>
//                                       {existingAttachments.map((attachment) => (
//                                         <div
//                                           key={attachment.id}
//                                           className='attachment-preview-card existing'
//                                         >
//                                           <button
//                                             type='button'
//                                             className='attachment-remove-btn'
//                                             onClick={() =>
//                                               removeAttachment(
//                                                 attachment.id,
//                                                 true
//                                               )
//                                             }
//                                             title='Remove file'
//                                           >
//                                             <i className='fa fa-times'></i>
//                                           </button>

//                                           <div className='attachment-preview-header'>
//                                             <div className='attachment-file-icon'>
//                                               <i
//                                                 className={`fa ${getFileIcon(
//                                                   attachment.type
//                                                 )}`}
//                                               ></i>
//                                             </div>
//                                             <div className='attachment-file-info'>
//                                               <img
//                                                 src={
//                                                   URI + attachment.url ||
//                                                   '/placeholder.svg'
//                                                 }
//                                                 alt={attachment.name}
//                                                 className='attachment-image-preview'
//                                               />

//                                               <p className='attachment-existing-badge'>
//                                                 Existing File
//                                               </p>
//                                             </div>
//                                           </div>
//                                           <div
//                                             style={{
//                                               textAlign: 'center',
//                                               marginTop: '8px',
//                                             }}
//                                           >
//                                             <a
//                                               href={attachment.url}
//                                               target='_blank'
//                                               rel='noopener noreferrer'
//                                               className='btn btn-sm btn-outline-primary'
//                                             >
//                                               <i className='fa fa-download me-1'></i>
//                                               Download
//                                             </a>
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 )}

//                                 {/* New Attachments Upload */}
//                                 <div
//                                   className={`enhanced-attachment-section ${
//                                     isDragOver ? 'drag-over' : ''
//                                   }`}
//                                   onDrop={handleDrop}
//                                   onDragOver={handleDragOver}
//                                   onDragLeave={handleDragLeave}
//                                   onClick={() =>
//                                     document
//                                       .getElementById('attachment-input')
//                                       .click()
//                                   }
//                                 >
//                                   <div className='attachment-upload-icon'>
//                                     <i className='fa fa-cloud-upload-alt'></i>
//                                   </div>
//                                   <h4 className='attachment-upload-title'>
//                                     {isDragOver
//                                       ? 'Drop files here'
//                                       : 'Add New Attachments'}
//                                   </h4>
//                                   <p className='attachment-upload-subtitle'>
//                                     Drag and drop files here, or click to browse
//                                   </p>
//                                   <button
//                                     type='button'
//                                     className='attachment-upload-button'
//                                   >
//                                     <i className='fa fa-plus me-2'></i>
//                                     Choose Files
//                                   </button>
//                                   <input
//                                     id='attachment-input'
//                                     type='file'
//                                     multiple
//                                     className='attachment-file-input'
//                                     onChange={(e) =>
//                                       pickImage({
//                                         field: 'attachments',
//                                         value: e.target.files,
//                                       })
//                                     }
//                                   />
//                                 </div>

//                                 {/* New Attachments Preview */}
//                                 {attachmentPreviews.length > 0 && (
//                                   <div className='attachment-previews'>
//                                     <h5
//                                       style={{
//                                         fontSize: '16px',
//                                         fontWeight: '600',
//                                         marginBottom: '16px',
//                                       }}
//                                     >
//                                       <i className='fa fa-plus-circle text-primary me-2'></i>
//                                       New Files ({attachmentPreviews.length})
//                                     </h5>
//                                     <div className='attachment-preview-grid'>
//                                       {attachmentPreviews.map((attachment) => (
//                                         <div
//                                           key={attachment.id}
//                                           className='attachment-preview-card'
//                                         >
//                                           <button
//                                             type='button'
//                                             className='attachment-remove-btn'
//                                             onClick={() =>
//                                               removeAttachment(attachment.id)
//                                             }
//                                             title='Remove file'
//                                           >
//                                             <i className='fa fa-times'></i>
//                                           </button>

//                                           {attachment.preview && (
//                                             <img
//                                               src={
//                                                 attachment.preview ||
//                                                 '/placeholder.svg'
//                                               }
//                                               alt={attachment.name}
//                                               className='attachment-image-preview'
//                                             />
//                                           )}

//                                           <div className='attachment-preview-header'>
//                                             <div className='attachment-file-icon'>
//                                               <i
//                                                 className={`fa ${getFileIcon(
//                                                   attachment.type
//                                                 )}`}
//                                               ></i>
//                                             </div>
//                                             <div className='attachment-file-info'>
//                                               <h6
//                                                 className='attachment-file-name'
//                                                 title={attachment.name}
//                                               >
//                                                 {attachment.name}
//                                               </h6>
//                                               <p className='attachment-file-size'>
//                                                 {formatFileSize(
//                                                   attachment.size
//                                                 )}
//                                               </p>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 )}
//                               </div>

//                               {/* Status Section */}
//                               <div className='enhanced-form-section'>
//                                 <h3 className='enhanced-section-title'>
//                                   <div className='enhanced-section-icon'>
//                                     <i className='fa fa-flag'></i>
//                                   </div>
//                                   Status & Review
//                                 </h3>
//                                 <div className='row'>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Review Status</label>
//                                       <SelectBox
//                                         name='review_status'
//                                         placeholder='Select review status'
//                                       >
//                                         <option value=''>
//                                           Select Review Status
//                                         </option>
//                                         {dropdownOptions.review_status &&
//                                           dropdownOptions.review_status.map(
//                                             (item) => (
//                                               <option
//                                                 key={item.value}
//                                                 value={item.value}
//                                               >
//                                                 {item.label}
//                                               </option>
//                                             )
//                                           )}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                   <div className='col-md-6'>
//                                     <div className='form-group'>
//                                       <label>Activity Status</label>
//                                       <SelectBox
//                                         name='activity_status'
//                                         placeholder='Select activity status'
//                                       >
//                                         <option value=''>
//                                           Select Activity Status
//                                         </option>
//                                         {dropdownOptions.activity_status &&
//                                           dropdownOptions.activity_status.map(
//                                             (item) => (
//                                               <option
//                                                 key={item.value}
//                                                 value={item.value}
//                                               >
//                                                 {item.label}
//                                               </option>
//                                             )
//                                           )}
//                                       </SelectBox>
//                                     </div>
//                                   </div>
//                                   <div className='col-md-12'>
//                                     <TextArea
//                                       label='Comments'
//                                       name='comments'
//                                       type='text'
//                                       placeholder='Enter any additional comments'
//                                     />
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>

//                             <div className='enhanced-form-actions'>
//                               <button
//                                 type='submit'
//                                 className={`enhanced-btn enhanced-btn-primary ${
//                                   formik.isSubmitting
//                                     ? 'enhanced-btn-loading'
//                                     : ''
//                                 }`}
//                                 disabled={formik.isSubmitting}
//                               >
//                                 {formik.isSubmitting ? (
//                                   <>
//                                     <span style={{ opacity: 0 }}>
//                                       <i className='fa fa-save me-2'></i>
//                                       Update Activity
//                                     </span>
//                                   </>
//                                 ) : (
//                                   <>
//                                     <i className='fa fa-save me-2'></i>
//                                     Update Activity
//                                   </>
//                                 )}
//                               </button>
//                               <button
//                                 type='button'
//                                 className='enhanced-btn enhanced-btn-secondary'
//                                 onClick={() => history.goBack()}
//                               >
//                                 <i className='fa fa-arrow-left me-2'></i>
//                                 Go Back
//                               </button>
//                             </div>
//                           </div>
//                         </div>

//                         <div className='col-md-4'>
//                           {/* Checklist Card */}
//                           <div className='enhanced-sidebar-card'>
//                             <div className='enhanced-sidebar-header'>
//                               <h4 className='enhanced-sidebar-title'>
//                                 <i className='fa fa-check-square'></i>
//                                 Process Checklist
//                               </h4>
//                               <p className='enhanced-sidebar-subtitle'>
//                                 Complete all required steps
//                               </p>
//                             </div>
//                             <div className='enhanced-sidebar-body'>
//                               <FieldArray
//                                 name='checklist'
//                                 render={(arrayHelper) => {
//                                   return (
//                                     <div>
//                                       {formik.values.checklist &&
//                                       formik.values.checklist.length > 0 ? (
//                                         formik.values.checklist.map(
//                                           (item, index) => (
//                                             <div
//                                               key={index}
//                                               className='checklist-item'
//                                             >
//                                               <CheckBox
//                                                 name={`checklist[${index}].is_checked`}
//                                                 type='checkbox'
//                                                 className='pt-0'
//                                               >
//                                                 {item.name}
//                                               </CheckBox>
//                                             </div>
//                                           )
//                                         )
//                                       ) : (
//                                         <div
//                                           style={{
//                                             textAlign: 'center',
//                                             color: '#6b7280',
//                                             padding: '20px',
//                                           }}
//                                         >
//                                           <i
//                                             className='fa fa-info-circle'
//                                             style={{
//                                               fontSize: '24px',
//                                               marginBottom: '8px',
//                                             }}
//                                           ></i>
//                                           <p>
//                                             Select a process to view checklist
//                                             items
//                                           </p>
//                                         </div>
//                                       )}
//                                     </div>
//                                   );
//                                 }}
//                               />
//                             </div>
//                           </div>

//                           {/* SOP Card */}
//                           <div className='enhanced-sidebar-card'>
//                             <div className='enhanced-sidebar-header'>
//                               <h4 className='enhanced-sidebar-title'>
//                                 <i className='fa fa-book'></i>
//                                 Standard Operating Procedure
//                               </h4>
//                               <p className='enhanced-sidebar-subtitle'>
//                                 Follow these guidelines
//                               </p>
//                             </div>
//                             <div className='enhanced-sidebar-body'>
//                               {all_processs &&
//                               all_processs.filter(
//                                 (item) => item._id == formik.values.process
//                               ) &&
//                               all_processs.filter(
//                                 (item) => item._id == formik.values.process
//                               )[0] &&
//                               all_processs.filter(
//                                 (item) => item._id == formik.values.process
//                               )[0].sop ? (
//                                 all_processs
//                                   .filter(
//                                     (item) => item._id == formik.values.process
//                                   )[0]
//                                   .sop.map((item, index) => (
//                                     <div key={index} className='sop-item'>
//                                       <div className='sop-icon'>
//                                         <i className='fa fa-list-ol'></i>
//                                       </div>
//                                       <div
//                                         className='sop-content'
//                                         dangerouslySetInnerHTML={{
//                                           __html: item.name,
//                                         }}
//                                       />
//                                     </div>
//                                   ))
//                               ) : (
//                                 <div
//                                   style={{
//                                     textAlign: 'center',
//                                     color: '#6b7280',
//                                     padding: '20px',
//                                   }}
//                                 >
//                                   <i
//                                     className='fa fa-info-circle'
//                                     style={{
//                                       fontSize: '24px',
//                                       marginBottom: '8px',
//                                     }}
//                                   ></i>
//                                   <p>Select a process to view SOP guidelines</p>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </Form>
//                   );
//                 }}
//               </Formik>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EnhancedEditActivity;

'use client';

import { useState, useEffect } from 'react';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import { uploadGallery } from '../../shared/upload';
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/activitys_enum';
import {
  useUpdateActivity,
  useSingleActivity,
  useGetDropdownOptions,
} from '../../shared/hooks/UseActivity';
import { FieldArray, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  CheckBox,
  SelectBox,
  TextArea,
  TextInput,
} from '../../components/Form/Form';
import { useSelectAllProcess } from '../../shared/hooks/UseProcess';
import EditorWYSIWYG from '../../components/EditorWYSIWYG';
import moment from 'moment';
import { useMutation } from '@tanstack/react-query';
import api from '../../domain/api';
import toast from 'react-hot-toast';
import { URI } from '../../domain/constant';

const EnhancedEditActivity = ({ match }) => {
  const history = useHistory();
  const [single_data] = useSingleActivity(match.params.id);
  const [updateData] = useUpdateActivity();
  const { activity_loading, activity, edit_activity_loading } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);
  const [imagePicked, setImagePicked] = useState(null);
  const [attachmentPreviews, setAttachmentPreviews] = useState([]);
  const [existingAttachments, setExistingAttachments] = useState([]);
  const [isDragOver, setIsDragOver] = useState(false);

  const [process_data] = useSelectAllProcess();
  const { all_processs } = process_data;

  console.log('existingAttachments', existingAttachments);

  // Handle existing attachments when activity loads
  useEffect(() => {
    if (activity && activity.attachments) {
      const existing = Array.isArray(activity?.attachments)
        ? activity?.attachments?.map((attachment, index) => {
            // Get file extension for type
            const ext = attachment.split('.').pop().toLowerCase();
            let type = '';
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext))
              type = 'image/*';
            else if (['pdf'].includes(ext)) type = 'application/pdf';
            else if (['doc', 'docx'].includes(ext)) type = 'application/msword';
            else if (['xls', 'xlsx'].includes(ext))
              type = 'application/vnd.ms-excel';
            else if (['zip', 'rar'].includes(ext)) type = 'application/zip';
            else type = '';

            return {
              id: `existing-${index}`,
              name: attachment?.split(/[\\/]/).pop() || 'Unknown file',
              url: attachment?.startsWith('http')
                ? attachment
                : `${process.env.REACT_APP_API_URL || ''}${attachment}`,
              isExisting: true,
              type,
            };
          })
        : [];

      setExistingAttachments(existing);
    }
  }, [activity]);

  const pickImage = ({ field, value }) => {
    const imagesCollection = imagePicked ? imagePicked : {};
    imagesCollection[field] = value;
    setImagePicked(imagesCollection);
    setFeaturedImage(imagesCollection);

    // Create previews for new attachments
    if (field === 'attachments' && value) {
      const files = Array.from(value);
      const previews = files.map((file, index) => ({
        id: Date.now() + index,
        file: file,
        name: file.name,
        size: file.size,
        type: file.type,
        preview: file.type.startsWith('image/')
          ? URL.createObjectURL(file)
          : null,
        isExisting: false,
      }));
      setAttachmentPreviews(previews);
    }
  };

  const removeAttachment = (id, isExisting = false) => {
    if (isExisting) {
      setExistingAttachments((prev) => prev?.filter((item) => item.id !== id));
    } else {
      const updatedPreviews = attachmentPreviews.filter(
        (item) => item.id !== id
      );
      setAttachmentPreviews(updatedPreviews);

      // Update the actual files
      const updatedFiles = updatedPreviews.map((item) => item.file);
      const fileList = new DataTransfer();
      updatedFiles.forEach((file) => fileList.items.add(file));

      pickImage({
        field: 'attachments',
        value: fileList.files,
      });
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    const fileList = new DataTransfer();
    files.forEach((file) => fileList.items.add(file));

    pickImage({
      field: 'attachments',
      value: fileList.files,
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    );
  };

  const getFileIcon = (type) => {
    if (type && type.startsWith('image/')) return 'fa-image';
    if (type && type.includes('pdf')) return 'fa-file-pdf';
    if (type && type.includes('word')) return 'fa-file-word';
    if (
      (type && type.includes('excel')) ||
      (type && type.includes('spreadsheet'))
    )
      return 'fa-file-excel';
    if ((type && type.includes('zip')) || (type && type.includes('rar')))
      return 'fa-file-archive';
    return 'fa-file';
  };

  const editActivityMutation = useMutation({
    mutationFn: async (data) => {
      const resp = await api.put(`/activitys/${data?.id}`, data);
      return resp.data;
    },
    onSuccess: () => {
      toast.success('Activity updated successfully!');
      history.push(`/${LINK_URL}/${match.params.id}/view`);
    },
    onError: (error) => {
      toast.error('Failed to update activity: ' + error.message);
    },
  });

  const submitFormClicked = async (values) => {
    const uploaded = await uploadGallery(featuredImage?.attachments || []);

    editActivityMutation.mutate({
      ...values,
      id: activity._id,
      attachments: [
        ...uploaded,
        ...(existingAttachments?.map((item) => item.url) || []),
      ],
    });
  };

  const [dropdownOptions] = useGetDropdownOptions();

  if (activity_loading) {
    return (
      <div className='pace-done'>
        <div>
          <Header />
          <BreadCrumb
            title={`Edit ${PAGE_SINGLE_TITLE}`}
            mainLinkTitle={PAGE_TITLE}
            mainLinkUrl={LINK_URL}
            activeLink='Edit'
          />
        </div>
        <div
          className='d-flex justify-content-center align-items-center'
          style={{ minHeight: '50vh' }}
        >
          <Spinner />
        </div>
      </div>
    );
  }

  if (!activity) {
    return (
      <div className='pace-done'>
        <div>
          <Header />
          <BreadCrumb
            title={`Edit ${PAGE_SINGLE_TITLE}`}
            mainLinkTitle={PAGE_TITLE}
            mainLinkUrl={LINK_URL}
            activeLink='Edit'
          />
        </div>
        <div className='container-fluid'>
          <div className='alert alert-warning'>Activity not found</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <style jsx>{`
        .enhanced-activity-container {
          background: linear-gradient(
            135deg,
            #f8fafc 0%,
            #fef2f2 50%,
            #fff1f2 100%
          );
          min-height: 100vh;
          padding: 20px 0;
        }

        .enhanced-form-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #f1f5f9;
          overflow: hidden;
          margin-bottom: 24px;
        }

        .enhanced-form-header {
          background: linear-gradient(
            135deg,
            #1e293b 0%,
            #334155 25%,
            #dc2626 75%,
            #b91c1c 100%
          );
          color: white;
          padding: 24px 28px;
          position: relative;
        }

        .enhanced-form-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 50%
          );
          pointer-events: none;
        }

        .enhanced-form-title {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 8px 0;
          position: relative;
          z-index: 1;
        }

        .enhanced-form-subtitle {
          font-size: 14px;
          opacity: 0.9;
          margin: 0;
          position: relative;
          z-index: 1;
        }

        .enhanced-form-actions-header {
          display: flex;
          gap: 12px;
          margin-top: 16px;
        }

        .enhanced-header-btn {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 6px;
          padding: 8px 16px;
          font-size: 12px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }

        .enhanced-header-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          color: white;
          text-decoration: none;
          transform: translateY(-1px);
        }

        .enhanced-form-body {
          padding: 32px 28px;
        }

        .enhanced-form-section {
          margin-bottom: 32px;
        }

        .enhanced-section-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .enhanced-section-icon {
          width: 32px;
          height: 32px;
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 14px;
        }

        /* Enhanced Form Controls */
        .form-group {
          margin-bottom: 24px;
        }

        .form-group label {
          font-weight: 600;
          color: #374151;
          margin-bottom: 8px;
          display: block;
          font-size: 14px;
        }

        .form-control {
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px 16px;
          font-size: 14px;
          transition: all 0.2s ease;
          background: #fafafa;
        }

        .form-control:focus {
          outline: none;
          border-color: #dc2626;
          background: white;
          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
        }

        /* Enhanced Attachment Section */
        .enhanced-attachment-section {
          background: #f9fafb;
          border: 2px dashed #d1d5db;
          border-radius: 12px;
          padding: 24px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
        }

        .enhanced-attachment-section.drag-over {
          border-color: #dc2626;
          background: #fef2f2;
          transform: scale(1.02);
        }

        .enhanced-attachment-section:hover {
          border-color: #dc2626;
          background: #fef2f2;
        }

        .attachment-upload-icon {
          width: 64px;
          height: 64px;
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
          color: white;
          font-size: 24px;
        }

        .attachment-upload-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 8px;
        }

        .attachment-upload-subtitle {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 16px;
        }

        .attachment-upload-button {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          color: white;
          border: none;
          border-radius: 8px;
          padding: 10px 20px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .attachment-upload-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
        }

        .attachment-file-input {
          position: absolute;
          opacity: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }

        /* Attachment Previews */
        .attachment-previews {
          margin-top: 20px;
        }

        .attachment-preview-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
          gap: 12px;
          margin-top: 16px;
        }

        .attachment-preview-card {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 12px;
          transition: all 0.2s ease;
          position: relative;
          min-height: 160px;
          display: flex;
          flex-direction: column;
        }

        .attachment-preview-card.existing {
          border-color: #10b981;
          background: #f0fdf4;
        }

        .attachment-preview-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .attachment-remove-btn {
          position: absolute;
          top: 6px;
          right: 6px;
          background: #ef4444;
          color: white;
          border: none;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 10px;
          transition: all 0.2s ease;
          z-index: 2;
        }

        .attachment-remove-btn:hover {
          background: #dc2626;
          transform: scale(1.1);
        }

        .attachment-image-preview {
          width: 100%;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          margin-bottom: 8px;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .attachment-file-icon-large {
          width: 100%;
          height: 80px;
          background: #f3f4f6;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6b7280;
          font-size: 24px;
          margin-bottom: 8px;
        }

        .attachment-file-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .attachment-file-name {
          font-size: 12px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 4px 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.2;
        }

        .attachment-file-size {
          font-size: 10px;
          color: #6b7280;
          margin: 0 0 8px 0;
        }

        .attachment-existing-badge {
          font-size: 9px;
          background: #10b981;
          color: white;
          padding: 2px 6px;
          border-radius: 4px;
          margin: 0 0 8px 0;
          text-align: center;
          display: inline-block;
        }

        .attachment-download-btn {
          background: #3b82f6;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 6px 12px;
          font-size: 10px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          margin-top: auto;
        }

        .attachment-download-btn:hover {
          background: #2563eb;
          transform: translateY(-1px);
          text-decoration: none;
          color: white;
        }

        /* Sidebar Cards */
        .enhanced-sidebar-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          border: 1px solid #f1f5f9;
          margin-bottom: 20px;
          overflow: hidden;
        }

        .enhanced-sidebar-header {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          padding: 16px 20px;
          border-bottom: 1px solid #e5e7eb;
        }

        .enhanced-sidebar-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 4px 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .enhanced-sidebar-subtitle {
          font-size: 12px;
          color: #6b7280;
          margin: 0;
        }

        .enhanced-sidebar-body {
          padding: 20px;
        }

        .checklist-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          margin-bottom: 8px;
          transition: all 0.2s ease;
        }

        .checklist-item:hover {
          background: #f3f4f6;
        }

        .checklist-item input[type='checkbox'] {
          width: 18px;
          height: 18px;
          accent-color: #dc2626;
        }

        .checklist-item label {
          font-size: 14px;
          color: #374151;
          margin: 0;
          cursor: pointer;
          flex: 1;
        }

        .sop-item {
          display: flex;
          gap: 12px;
          padding: 12px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          margin-bottom: 12px;
        }

        .sop-icon {
          width: 32px;
          height: 32px;
          background: #dc2626;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 14px;
          flex-shrink: 0;
        }

        .sop-content {
          flex: 1;
          font-size: 14px;
          color: #374151;
          line-height: 1.5;
        }

        /* Enhanced Buttons */
        .enhanced-btn {
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.2s ease;
          border: none;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .enhanced-btn-primary {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
          color: white;
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
        }

        .enhanced-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
        }

        .enhanced-btn-secondary {
          background: #f8f9fa;
          color: #6b7280;
          border: 1px solid #e5e7eb;
        }

        .enhanced-btn-secondary:hover {
          background: #e5e7eb;
          color: #374151;
        }

        .enhanced-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .enhanced-btn-loading {
          position: relative;
        }

        .enhanced-btn-loading::before {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          100% {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }

        /* Form Actions */
        .enhanced-form-actions {
          background: #f9fafb;
          border-top: 1px solid #e5e7eb;
          padding: 20px 28px;
          display: flex;
          justify-content: center;
          gap: 16px;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .enhanced-form-body {
            padding: 20px;
          }

          .enhanced-form-header {
            padding: 20px;
          }

          .attachment-preview-grid {
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
          }

          .enhanced-form-actions {
            padding: 16px 20px;
            flex-direction: column;
          }
        }
      `}</style>

      <div className='pace-done'>
        <div>
          <Header />
          <BreadCrumb
            title={`Edit ${PAGE_SINGLE_TITLE}`}
            mainLinkTitle={PAGE_TITLE}
            mainLinkUrl={LINK_URL}
            activeLink='Edit'
          />
        </div>

        <div className='enhanced-activity-container'>
          <div className='container-fluid'>
            <div className='col-lg-12'>
              <Formik
                initialValues={{
                  task_name:
                    activity && activity.task_name ? activity.task_name : '',
                  assigned_to:
                    activity && activity.assigned_to && activity.assigned_to._id
                      ? activity.assigned_to._id
                      : '',
                  activity_cycle:
                    activity && activity.activity_cycle
                      ? activity.activity_cycle._id
                      : '',
                  due_time:
                    activity && activity.due_time
                      ? moment(activity.due_time).format('yyyy-MM-DDThh:mm')
                      : '',
                  client:
                    activity && activity.client && activity.client._id
                      ? activity.client._id
                      : '',
                  process:
                    activity && activity.process && activity.process._id
                      ? activity.process._id
                      : '',
                  checklist: activity.checklist ? activity.checklist : [],
                  estimated_time:
                    activity && activity.estimated_time
                      ? activity.estimated_time
                      : '',
                  actual_time:
                    activity && activity.actual_time
                      ? activity.actual_time
                      : '',
                  task_description:
                    activity && activity.task_description
                      ? activity.task_description
                      : '',
                  attachments:
                    activity && activity.attachments
                      ? activity.attachments
                      : '',
                  review_status:
                    activity &&
                    activity.review_status &&
                    activity.review_status._id
                      ? activity.review_status._id
                      : '',
                  activity_status:
                    activity &&
                    activity.activity_status &&
                    activity.activity_status._id
                      ? activity.activity_status._id
                      : '',
                  comments:
                    activity && activity.comments ? activity.comments : '',
                }}
                validationSchema={Yup.object({
                  task_name: Yup.string().required('Required'),
                  assigned_to: Yup.string().required('Required'),
                  due_time: Yup.string().required('Required'),
                  client: Yup.string().required('Required'),
                  process: Yup.string().required('Required'),
                  review_status: Yup.string().required('Required'),
                  activity_status: Yup.string().required('Required'),
                })}
                onSubmit={async (values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  submitFormClicked(values);
                  setSubmitting(false);
                }}
              >
                {(formik) => {
                  return (
                    <Form>
                      <div className='row'>
                        <div className='col-md-8'>
                          <div className='enhanced-form-card'>
                            <div className='enhanced-form-header'>
                              <h2 className='enhanced-form-title'>
                                <i className='fa fa-edit me-2'></i>
                                {activity[Object.keys(inputFields)[0]]} - Edit
                                Activity
                              </h2>
                              <p className='enhanced-form-subtitle'>
                                Update the activity details below to modify the
                                existing task
                              </p>
                              <div className='enhanced-form-actions-header'>
                                <Link
                                  to={`/${LINK_URL}`}
                                  className='enhanced-header-btn'
                                >
                                  <i className='fa fa-angle-left'></i>
                                  {PAGE_TITLE}
                                </Link>
                                <Link
                                  to={`/${LINK_URL}/${activity._id}/view`}
                                  className='enhanced-header-btn'
                                >
                                  <i className='fa fa-eye'></i>
                                  View
                                </Link>
                              </div>
                            </div>

                            <div className='enhanced-form-body'>
                              {/* Basic Information Section */}
                              <div className='enhanced-form-section'>
                                <h3 className='enhanced-section-title'>
                                  <div className='enhanced-section-icon'>
                                    <i className='fa fa-info'></i>
                                  </div>
                                  Basic Information
                                </h3>
                                <div className='row'>
                                  <div className='col-md-6'>
                                    <TextInput
                                      label='Task Name'
                                      name='task_name'
                                      type='text'
                                      placeholder='Enter task name'
                                    />
                                  </div>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Assigned to</label>
                                      <SelectBox
                                        name='assigned_to'
                                        placeholder='Select assigned person'
                                      >
                                        <option value=''>
                                          Select Assigned to
                                        </option>
                                        {dropdownOptions.assigned_to &&
                                          dropdownOptions.assigned_to.map(
                                            (item) => (
                                              <option
                                                key={item.value}
                                                value={item.value}
                                              >
                                                {item.label}
                                              </option>
                                            )
                                          )}
                                      </SelectBox>
                                    </div>
                                  </div>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Activity Cycle</label>
                                      <SelectBox
                                        name='activity_cycle'
                                        placeholder='Select cycle'
                                      >
                                        <option value=''>
                                          Select Activity Cycle
                                        </option>
                                        {dropdownOptions.activity_cycle &&
                                          dropdownOptions.activity_cycle.map(
                                            (item) => (
                                              <option
                                                key={item.value}
                                                value={item.value}
                                              >
                                                {item.label}
                                              </option>
                                            )
                                          )}
                                      </SelectBox>
                                    </div>
                                  </div>
                                  <div className='col-md-6'>
                                    <TextInput
                                      label='Due Time'
                                      name='due_time'
                                      type='datetime-local'
                                      placeholder='Select due date and time'
                                    />
                                  </div>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Client</label>
                                      <SelectBox
                                        name='client'
                                        placeholder='Select client'
                                      >
                                        <option value=''>Select Client</option>
                                        {dropdownOptions.client &&
                                          dropdownOptions.client.map((item) => (
                                            <option
                                              key={item.value}
                                              value={item.value}
                                            >
                                              {item.label}
                                            </option>
                                          ))}
                                      </SelectBox>
                                    </div>
                                  </div>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Process</label>
                                      <SelectBox
                                        name='process'
                                        placeholder='Select process'
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            'process',
                                            e.target.value
                                          );
                                          formik.setFieldValue('checklist', []);
                                          if (all_processs) {
                                            const filteredData =
                                              all_processs.filter(
                                                (item, index) =>
                                                  item._id == e.target.value
                                              );
                                            if (
                                              filteredData &&
                                              filteredData.length > 0
                                            ) {
                                              const checklistData =
                                                filteredData[0].checklist;
                                              if (
                                                checklistData &&
                                                checklistData.length > 0
                                              ) {
                                                const checklistDataMapped =
                                                  checklistData.map((item) => {
                                                    return {
                                                      name: item.name,
                                                      is_checked: false,
                                                    };
                                                  });
                                                formik.setFieldValue(
                                                  'checklist',
                                                  checklistDataMapped
                                                );
                                              }
                                            }
                                          }
                                        }}
                                      >
                                        <option value=''>Select Process</option>
                                        {dropdownOptions.process &&
                                          dropdownOptions.process.map(
                                            (item) => (
                                              <option
                                                key={item.value}
                                                value={item.value}
                                              >
                                                {item.label}
                                              </option>
                                            )
                                          )}
                                      </SelectBox>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Time Tracking Section */}
                              <div className='enhanced-form-section'>
                                <h3 className='enhanced-section-title'>
                                  <div className='enhanced-section-icon'>
                                    <i className='fa fa-clock'></i>
                                  </div>
                                  Time Tracking
                                </h3>
                                <div className='row'>
                                  <div className='col-md-6'>
                                    <TextInput
                                      label='Estimated Time (minutes)'
                                      name='estimated_time'
                                      type='number'
                                      placeholder='Enter estimated time'
                                    />
                                  </div>
                                  <div className='col-md-6'>
                                    <TextInput
                                      label='Actual Time (minutes)'
                                      name='actual_time'
                                      type='number'
                                      placeholder='Enter actual time'
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Description Section */}
                              <div className='enhanced-form-section'>
                                <h3 className='enhanced-section-title'>
                                  <div className='enhanced-section-icon'>
                                    <i className='fa fa-align-left'></i>
                                  </div>
                                  Task Description
                                </h3>
                                <div className='form-group'>
                                  <EditorWYSIWYG
                                    value={
                                      formik.values.task_description
                                        ? formik.values.task_description
                                        : ''
                                    }
                                    name={'task_description'}
                                    changeValue={(value) => {
                                      formik.setFieldValue(
                                        'task_description',
                                        value
                                      );
                                    }}
                                  />
                                  {formik.errors &&
                                    formik.errors['task_description'] && (
                                      <p className='text-danger'>Required</p>
                                    )}
                                </div>
                              </div>

                              {/* Enhanced Attachments Section */}
                              <div className='enhanced-form-section'>
                                <h3 className='enhanced-section-title'>
                                  <div className='enhanced-section-icon'>
                                    <i className='fa fa-paperclip'></i>
                                  </div>
                                  Attachments
                                </h3>

                                {/* Existing Attachments */}
                                {existingAttachments.length > 0 && (
                                  <div className='attachment-previews mb-2'>
                                    <h5
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        marginBottom: '16px',
                                      }}
                                    >
                                      <i className='fa fa-check-circle text-success me-2'></i>
                                      Current Files (
                                      {existingAttachments.length})
                                    </h5>
                                    <div className='attachment-preview-grid'>
                                      {existingAttachments.map((attachment) => (
                                        <div
                                          key={attachment.id}
                                          className='attachment-preview-card existing'
                                        >
                                          <button
                                            type='button'
                                            className='attachment-remove-btn'
                                            onClick={() =>
                                              removeAttachment(
                                                attachment.id,
                                                true
                                              )
                                            }
                                            title='Remove file'
                                          >
                                            <i className='fa fa-times'></i>
                                          </button>

                                          {attachment.type &&
                                          attachment.type.startsWith(
                                            'image/'
                                          ) ? (
                                            <img
                                              src={
                                                URI + attachment.url ||
                                                '/placeholder.svg'
                                              }
                                              alt={attachment.name}
                                              className='attachment-image-preview'
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display =
                                                  'flex';
                                              }}
                                            />
                                          ) : (
                                            <div className='attachment-file-icon-large'>
                                              <i
                                                className={`fa ${getFileIcon(
                                                  attachment.type
                                                )}`}
                                              ></i>
                                            </div>
                                          )}

                                          <div className='attachment-file-info'>
                                            <h6
                                              className='attachment-file-name'
                                              title={attachment.name}
                                            >
                                              {attachment.name}
                                            </h6>
                                            <p className='attachment-existing-badge'>
                                              Existing File
                                            </p>
                                            <a
                                              href={attachment.url}
                                              target='_blank'
                                              rel='noopener noreferrer'
                                              className='attachment-download-btn'
                                            >
                                              <i className='fa fa-download'></i>
                                              Download
                                            </a>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {/* New Attachments Upload */}
                                <div
                                  className={`enhanced-attachment-section ${
                                    isDragOver ? 'drag-over' : ''
                                  }`}
                                  onDrop={handleDrop}
                                  onDragOver={handleDragOver}
                                  onDragLeave={handleDragLeave}
                                  onClick={() =>
                                    document
                                      .getElementById('attachment-input')
                                      .click()
                                  }
                                >
                                  <div className='attachment-upload-icon'>
                                    <i className='fa fa-cloud-upload-alt'></i>
                                  </div>
                                  <h4 className='attachment-upload-title'>
                                    {isDragOver
                                      ? 'Drop files here'
                                      : 'Add New Attachments'}
                                  </h4>
                                  <p className='attachment-upload-subtitle'>
                                    Drag and drop files here, or click to browse
                                  </p>
                                  <button
                                    type='button'
                                    className='attachment-upload-button'
                                  >
                                    <i className='fa fa-plus me-2'></i>
                                    Choose Files
                                  </button>
                                  <input
                                    id='attachment-input'
                                    type='file'
                                    multiple
                                    className='attachment-file-input'
                                    onChange={(e) =>
                                      pickImage({
                                        field: 'attachments',
                                        value: e.target.files,
                                      })
                                    }
                                  />
                                </div>

                                {/* New Attachments Preview */}
                                {attachmentPreviews.length > 0 && (
                                  <div className='attachment-previews'>
                                    <h5
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        marginBottom: '16px',
                                      }}
                                    >
                                      <i className='fa fa-plus-circle text-primary me-2'></i>
                                      New Files ({attachmentPreviews.length})
                                    </h5>
                                    <div className='attachment-preview-grid'>
                                      {attachmentPreviews.map((attachment) => (
                                        <div
                                          key={attachment.id}
                                          className='attachment-preview-card'
                                        >
                                          <button
                                            type='button'
                                            className='attachment-remove-btn'
                                            onClick={() =>
                                              removeAttachment(attachment.id)
                                            }
                                            title='Remove file'
                                          >
                                            <i className='fa fa-times'></i>
                                          </button>

                                          {attachment.preview ? (
                                            <img
                                              src={
                                                attachment.preview ||
                                                '/placeholder.svg'
                                              }
                                              alt={attachment.name}
                                              className='attachment-image-preview'
                                            />
                                          ) : (
                                            <div className='attachment-file-icon-large'>
                                              <i
                                                className={`fa ${getFileIcon(
                                                  attachment.type
                                                )}`}
                                              ></i>
                                            </div>
                                          )}

                                          <div className='attachment-file-info'>
                                            <h6
                                              className='attachment-file-name'
                                              title={attachment.name}
                                            >
                                              {attachment.name}
                                            </h6>
                                            <p className='attachment-file-size'>
                                              {formatFileSize(attachment.size)}
                                            </p>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Status Section */}
                              <div className='enhanced-form-section'>
                                <h3 className='enhanced-section-title'>
                                  <div className='enhanced-section-icon'>
                                    <i className='fa fa-flag'></i>
                                  </div>
                                  Status & Review
                                </h3>
                                <div className='row'>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Review Status</label>
                                      <SelectBox
                                        name='review_status'
                                        placeholder='Select review status'
                                      >
                                        <option value=''>
                                          Select Review Status
                                        </option>
                                        {dropdownOptions.review_status &&
                                          dropdownOptions.review_status.map(
                                            (item) => (
                                              <option
                                                key={item.value}
                                                value={item.value}
                                              >
                                                {item.label}
                                              </option>
                                            )
                                          )}
                                      </SelectBox>
                                    </div>
                                  </div>
                                  <div className='col-md-6'>
                                    <div className='form-group'>
                                      <label>Activity Status</label>
                                      <SelectBox
                                        name='activity_status'
                                        placeholder='Select activity status'
                                      >
                                        <option value=''>
                                          Select Activity Status
                                        </option>
                                        {dropdownOptions.activity_status &&
                                          dropdownOptions.activity_status.map(
                                            (item) => (
                                              <option
                                                key={item.value}
                                                value={item.value}
                                              >
                                                {item.label}
                                              </option>
                                            )
                                          )}
                                      </SelectBox>
                                    </div>
                                  </div>
                                  <div className='col-md-12'>
                                    <TextArea
                                      label='Comments'
                                      name='comments'
                                      type='text'
                                      placeholder='Enter any additional comments'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='enhanced-form-actions'>
                              <button
                                type='submit'
                                className={`enhanced-btn enhanced-btn-primary ${
                                  formik.isSubmitting
                                    ? 'enhanced-btn-loading'
                                    : ''
                                }`}
                                disabled={formik.isSubmitting}
                              >
                                {formik.isSubmitting ? (
                                  <>
                                    <span style={{ opacity: 0 }}>
                                      <i className='fa fa-save me-2'></i>
                                      Update Activity
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <i className='fa fa-save me-2'></i>
                                    Update Activity
                                  </>
                                )}
                              </button>
                              <button
                                type='button'
                                className='enhanced-btn enhanced-btn-secondary'
                                onClick={() => history.goBack()}
                              >
                                <i className='fa fa-arrow-left me-2'></i>
                                Go Back
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className='col-md-4'>
                          {/* Checklist Card */}
                          <div className='enhanced-sidebar-card'>
                            <div className='enhanced-sidebar-header'>
                              <h4 className='enhanced-sidebar-title'>
                                <i className='fa fa-check-square'></i>
                                Process Checklist
                              </h4>
                              <p className='enhanced-sidebar-subtitle'>
                                Complete all required steps
                              </p>
                            </div>
                            <div className='enhanced-sidebar-body'>
                              <FieldArray
                                name='checklist'
                                render={(arrayHelper) => {
                                  return (
                                    <div>
                                      {formik.values.checklist &&
                                      formik.values.checklist.length > 0 ? (
                                        formik.values.checklist.map(
                                          (item, index) => (
                                            <div
                                              key={index}
                                              className='checklist-item'
                                            >
                                              <CheckBox
                                                name={`checklist[${index}].is_checked`}
                                                type='checkbox'
                                                className='pt-0'
                                              >
                                                {item.name}
                                              </CheckBox>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <div
                                          style={{
                                            textAlign: 'center',
                                            color: '#6b7280',
                                            padding: '20px',
                                          }}
                                        >
                                          <i
                                            className='fa fa-info-circle'
                                            style={{
                                              fontSize: '24px',
                                              marginBottom: '8px',
                                            }}
                                          ></i>
                                          <p>
                                            Select a process to view checklist
                                            items
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }}
                              />
                            </div>
                          </div>

                          {/* SOP Card */}
                          <div className='enhanced-sidebar-card'>
                            <div className='enhanced-sidebar-header'>
                              <h4 className='enhanced-sidebar-title'>
                                <i className='fa fa-book'></i>
                                Standard Operating Procedure
                              </h4>
                              <p className='enhanced-sidebar-subtitle'>
                                Follow these guidelines
                              </p>
                            </div>
                            <div className='enhanced-sidebar-body'>
                              {all_processs &&
                              all_processs.filter(
                                (item) => item._id == formik.values.process
                              ) &&
                              all_processs.filter(
                                (item) => item._id == formik.values.process
                              )[0] &&
                              all_processs.filter(
                                (item) => item._id == formik.values.process
                              )[0].sop ? (
                                all_processs
                                  .filter(
                                    (item) => item._id == formik.values.process
                                  )[0]
                                  .sop.map((item, index) => (
                                    <div key={index} className='sop-item'>
                                      <div className='sop-icon'>
                                        <i className='fa fa-list-ol'></i>
                                      </div>
                                      <div
                                        className='sop-content'
                                        dangerouslySetInnerHTML={{
                                          __html: item.name,
                                        }}
                                      />
                                    </div>
                                  ))
                              ) : (
                                <div
                                  style={{
                                    textAlign: 'center',
                                    color: '#6b7280',
                                    padding: '20px',
                                  }}
                                >
                                  <i
                                    className='fa fa-info-circle'
                                    style={{
                                      fontSize: '24px',
                                      marginBottom: '8px',
                                    }}
                                  ></i>
                                  <p>Select a process to view SOP guidelines</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnhancedEditActivity;
